export { handleExport };

function handleExport(data, fileName) {
  let blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const downloadUrl = window.URL.createObjectURL(blob);

  let a = document.createElement('a');
  if (typeof a.download === 'undefined') {
    window.location.href = downloadUrl;
  } else {
    a.href = downloadUrl;
    a.download = fileName;
    a.setAttribute('download', `${fileName}.xlsx`);
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}
